import type { RouteRecordRaw } from 'vue-router'

// AdminApp renders the sign-in itself while signed out, so `auth` only has to exist
// for the emailed link (/admin/auth?token=…): AdminSignIn reads the token on mount.
export const adminRoutes: RouteRecordRaw[] = [
  { path: '', redirect: '/admin/events' },
  { path: 'auth', name: 'admin.auth', component: () => import('./Blank.vue') },
  { path: 'events', name: 'admin.events', component: () => import('./EventsPage.vue') },
  { path: 'events/:slug', name: 'admin.event', component: () => import('./EventPage.vue'), props: true },
  { path: 'openers', name: 'admin.openers', component: () => import('./OpenersPage.vue') },
  { path: 'admins', name: 'admin.admins', component: () => import('./AdminsPage.vue') },
  { path: 'outbox', name: 'admin.outbox', component: () => import('./OutboxPage.vue') },
]
